export function getFontSizeOfHTMLElement(element: HTMLElement) {
    return parseInt(getComputedStyle(element, null).getPropertyValue("font-size"), 10);
}
